// extracted by mini-css-extract-plugin
export default {"back":"styles_back__y5Kil","backButton":"styles_backButton__b8kqE"};